var sidebar;
var sidebarButton;

var pageDialog;
var pageDialogTitle;

var videoDialog;
var backgroundVideo;

document.addEventListener("DOMContentLoaded", (event) => {
    sidebar = document.getElementById("sidebar");
    sidebarButton = document.getElementById("sidebar-button-check");

    testButton = document.getElementById("test-button");
    testDialog = document.getElementById("test-dialog");

    pageDialog = document.getElementById("page-dialog");
    pageDialogTitle = document.getElementById("page-dialog-title");

    videoDialog = document.getElementById("video-dialog");
    backgroundVideo = document.getElementById("background-video");

    sidebarButton.checked = false;
});

function sidebarButtonClicked()
{
    sidebarButton.checked = !sidebarButton.checked;
    // console.log("sidebar button clicked");
    // console.log(sidebarButton.checked);
    if(sidebarButton.checked) {
        sidebar.classList.add("visible");
    }
    else {
        sidebar.classList.remove("visible");
    }
}

function showPageDialog(page)
{
    // hide sidebar
    sidebarButton.checked = false;
    sidebar.classList.remove("visible");


    pageDialogTitle.innerText = "Loading..."
    pageDialog.show();
    

    var xhr = new XMLHttpRequest();
    xhr.open('GET', `${page}.html`, true);
    xhr.onload = function() {
        var pageDialogContent = document.getElementById("page-dialog-content");
        if (xhr.status === 200) {
            pageDialogTitle.innerText = page;
            pageDialogContent.innerHTML = xhr.responseText;
        }
        else {
            pageDialogTitle.innerText = ":(";
            pageDialogContent.innerText = "Error: " + xhr.status;
        }
    };
    xhr.send();

    // get this to change the URL somehow? also get the URL to auto-open the corresponding window?
    
    //var pageDialogContent = document.getElementById("page-dialog-content");
    // put pageContent inside pageDialogContent's innerHTML, but without using innerHTML
}

function dialogCloseButtonClicked()
{
    pageDialog.close();
}


function showVideoDialog()
{
    videoDialog.show();
    // also pause background video playback, it's distracting
    backgroundVideo.pause();
}

function videoCloseButtonClicked()
{
    videoDialog.close();

    backgroundVideo.play();
}